import React, { useEffect } from 'react'
import Grid from '@mui/material/Grid';
import Box from "@mui/material/Box";
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { connect } from "react-redux";
import { useDispatch } from "react-redux";
import PermissionElevationRequestForm from '../components/PermissionElevationRequestForm';
import { Link } from 'react-router-dom';
import LoaderComponent from '../components/LoaderComponent';
import { loadUserInformation, permissionUpdateRequest } from '../api/elevationapi';
import { getPermissions, getUserDetails, getUserDetailsLoading } from '../selector/selectors';
import { loadPermissionsList } from '../api/permissionsapi';
import swal from 'sweetalert';

const CreatePermissionsElevationRequest = ({
    isLoading,
    userDetails,
    permissionList,
    startLoadingPermissions,
    startLoadingUserInformation
}) => {

    const dispatch = useDispatch();
    const [message, setMessage] = React.useState('');
    const [value, setValue] = React.useState('1');
    const [updatedDataPermissionList, setUpdatedDataPermissionList] = React.useState([]);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    useEffect(() => {
        startLoadingUserInformation();
        startLoadingPermissions();
    }, [startLoadingUserInformation,startLoadingPermissions]);

    useEffect(() => {
        let filteredList = permissionList?.filter(permission =>  !userDetails?.permissions?.some(el => el.id === permission.id))
        let newArraylist = filteredList?.map(el => {
            return {...el,checked:false}
        })
        setUpdatedDataPermissionList(newArraylist);
    },[userDetails,permissionList]);


    const handleSwitchChange = (id) => (event) =>{
        const updatedData = updatedDataPermissionList.map(permission => {
            if(permission.id === id){
                return {...permission,checked:event.target.checked}
            }
            return permission;
        });
        setUpdatedDataPermissionList(updatedData);
    };

    const handleFormData = async () => {
        let permissions = updatedDataPermissionList;
        let messageBox  = message;
        let count = 0;
        permissions.map(val => val.checked ? count++ : 0);
        if(permissions.length <= 0 || count === 0){
            swal("Oops!", "Please select atleast one request permission!", "error");
            return false;
        }
        let userData = {
            'permissions'   :   permissions,
            'message'       :   messageBox
        };
        dispatch(permissionUpdateRequest(userData));
        setMessage('');
    }

    console.log('userDetails',userDetails)

    return (
        <Box sx={{ flexGrow: 1 }} >
            { isLoading ?  <LoaderComponent />: <></>}
            <Grid container >
                <TabContext value={value}>
                    <Grid item xs={12} md={12} lg={12} >
                        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                            <TabList onChange={handleChange} aria-label="">
                                <Link className="tabingLinks" to="/web/role/request">Role Elevation Request</Link>
                                <Tab label="Permissions Request" value="1" />
                            </TabList>
                        </Box>
                        <TabPanel value="1" sx={{p:0,pt:2}}>
                            <PermissionElevationRequestForm 
                                userDetails={userDetails}  
                                handleFormData={handleFormData}
                                permissionList={updatedDataPermissionList}
                                handleSwitchChange={handleSwitchChange}
                                setMessage={setMessage}
                                message={message}
                            />
                        </TabPanel>
                    </Grid>
                </TabContext>
            </Grid>
        </Box>
    )
}


const mapStateToProps = (state) => ({
    isLoading        :   getUserDetailsLoading(state),  
    userDetails      :   getUserDetails(state), 
    permissionList   :   getPermissions(state),
});
  
const mapDispatchToProps = (dispatch) => ({
    startLoadingPermissions: ()     => dispatch(loadPermissionsList()),
    startLoadingUserInformation:()  => dispatch(loadUserInformation()),
});
  
export default connect(mapStateToProps, mapDispatchToProps)(CreatePermissionsElevationRequest);